/* eslint-disable jsx-a11y/label-has-for */

import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";

import { StyledLabel } from "../../styles/InputList";

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
`;

const StyledCheckbox = styled.div`
  display: block;
  width: 2.25em;
  height: 2.25em;
  cursor: ${props => (props.readOnly ? "not-allowed" : "pointer")};
  background: ${props =>
    props.checked ? props.theme.secondary : props.theme.offWhite};
  border-radius: 2px;
  transition: all 150ms;
  position: relative;
  margin: 8px 0px 0px 0px;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 2px ${props => props.theme.lightgrey};
  }
  ${Icon} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 1.5em;
    visibility: ${props => (props.checked ? "visible" : "hidden")};
  }
`;
const CheckboxContainer = styled(StyledLabel)`
  cursor: pointer;
  width: 100%;
  font-size: ${props => (props.size === "small" ? 0.75 : 1)}rem;
  opacity: ${props => (props.disabled || props.readOnly ? "0.25" : "1")};
  ${StyledCheckbox} {
    margin-top: ${props => (props.label ? "0.25rem" : "0px")};
  }
`;

const Checkbox = ({
  name,
  size,
  checked,
  onChange,
  readOnly,
  disabled,
  label,
  ...props
}) => (
  <CheckboxContainer
    className="checkbox-container"
    disabled={disabled}
    label={!!label}
    readOnly={readOnly}
    size={size}
  >
    <HiddenCheckbox
      checked={checked}
      name={name}
      onChange={e => (!readOnly && !disabled ? onChange(e) : null)}
      {...props}
    />
    <StyledCheckbox checked={checked} disabled={disabled} readOnly={readOnly}>
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
);

Checkbox.propTypes = {
  name: PropTypes.string,
  size: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool
};

Checkbox.defaultProps = {
  onChange: e => console.log(e)
};

export default Checkbox;
